import { FilterOperators, FilterTypes } from "@/data/table";
import { ITemplateCategory } from "@/models/templates";
import i18n from "@/i18n";
import { IFilter } from "@/models/tables";

export const CategoryCodeFilter = (codes: ITemplateCategory["code"][]) => ({
  "filter[category.code]": codes.join()
});

export const NameFilter: () => IFilter = () => ({
  key: "name",
  label: i18n.t("_.name"),
  type: FilterTypes.STRING,
  operator: FilterOperators.CONTAINS
});

export const DefaultTemplateSlotsFilters: () => IFilter[] = () => {
  return [NameFilter()];
};
